// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".helper-text[data-v-74497787]{margin-left:2px}", ""]);
// Exports
module.exports = exports;
